import ZendeskAdaptor from './ZendeskAdaptor'

export default ZendeskAdaptor

export { useZendeskAPI } from './ZendeskAdaptorContext'
